import React from "react";
import PropTypes from "prop-types";
import { Col, Figure, Jumbotron, Row } from "react-bootstrap";

export default function FeaturedBlock(props) {
  return (
    <Jumbotron className="my-6 jumbotron-shadow">
      <Row className="align-items-center">
        {props.imageUrl && (
          <Col md={{ span: 6 }}>
            <Figure className="jumbotron-figure">
              <Figure.Image
                className="mb-0"
                fluid
                alt="liten"
                src={props.imageUrl}
              />
              {props.imageCaption && (
                <Figure.Caption>{props.imageCaption}</Figure.Caption>
              )}
            </Figure>
          </Col>
        )}
        <Col md={{ span: 6 }}>
          {props.title && <h2 className="mb-3">{props.title}</h2>}
          {props.lead && <p>{props.lead}</p>}
          {props.linkText && (
            <a href={props.linkUrl} className="link link-bold font-weight-bold">
              {props.linkText}
            </a>
          )}
        </Col>
      </Row>
    </Jumbotron>
  );
}

FeaturedBlock.propTypes = {
  imageUrl: PropTypes.string,
  imageCaption: PropTypes.string,
  title: PropTypes.string,
  lead: PropTypes.string,
  linkText: PropTypes.string,
  linkUrl: PropTypes.string,
};
